export default __webpack_public_path__ + "static/media/message-light.e9e7816b.svg";